import { uiRows } from './types-def.js';
/** `web/calendar` (1.O-3): the calendar editor. */
export const CALENDAR_INTERACTIONS = uiRows([
    {
        id: 'chrono.calendar.draft-diff-commit',
        module: 'web/calendar',
        behavior: 'A calendar edit is a draft with a diff preview until it is committed',
        owner: '1.O-3',
        since: 'exit-1b',
    },
]);
//# sourceMappingURL=calendar.js.map